// Suggestions often stringify numbers/booleans; detectors accept both native and string forms.

export function isNumberLike(value: unknown): boolean {
  if (typeof value === 'number') {
    return Number.isFinite(value);
  }
  if (typeof value === 'string') {
    if (value.trim() === '') {
      return false;
    }
    return Number.isFinite(Number(value));
  }
  return false;
}

export const BOOLEAN_STRING_VALUES = ['true', 'false'] as const;

const BOOLEAN_STRING_SET = new Set<string>(BOOLEAN_STRING_VALUES);

export function isBooleanLike(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return true;
  }
  if (typeof value === 'string') {
    return BOOLEAN_STRING_SET.has(value.toLowerCase());
  }
  return false;
}
